var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import AppLayout from '@/Layouts/AppLayout';
import { usePage } from '@inertiajs/react';
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import _ from 'lodash';
import { router } from '@inertiajs/react';
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
import Breadcrumb from "@/Jetstream/Breadcrumb";
function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(' ');
}
var items = [
    {
        id: "recents",
        label: "Recents",
    },
    {
        id: "home",
        label: "Home",
    },
    {
        id: "applications",
        label: "Applications",
    },
    {
        id: "desktop",
        label: "Desktop",
    },
    {
        id: "downloads",
        label: "Downloads",
    },
    {
        id: "documents",
        label: "Documents",
    },
];
export default function Create(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    var team = _a.team, bookingCalendars = _a.bookingCalendars, site = _a.site;
    var route = useRoute(Ziggy);
    var flash = usePage().props.flash;
    var _w = useState(true), open = _w[0], setOpen = _w[1];
    var calendarsIndex = _.keyBy(bookingCalendars, 'id');
    var formSchema = z.object({
        name: z.string().min(2, {
            message: "Name must be at least 2 characters.",
        }),
        domain: z.string(),
        subdomain: z.string(),
        domain_type: z.enum(["subdomain", "custom"], {
            required_error: "You need to select a domain type.",
        }),
        // items: z.array(z.string()).refine((value) => value.some((item) => item), {
        //     message: "You have to select at least one item.",
        // }),
        landing_config: z.object({
            calendars: z.array(z.number()).refine(function (value) { return value.some(function (item) { return item; }); }, {
                message: "You have to select at least one item.",
            }),
            colors: z.object({
                bg: z.string(),
                hero_bg: z.string(),
            }),
            content: z.object({
                hero_image: z.string(),
                heading: z.string(),
                sub_heading: z.string(),
                info_heading: z.string(),
                info_cards: z.array(z.object({
                    heading: z.string(),
                    content: z.string(),
                })),
            }),
        })
    });
    function slugify(title) {
        return title.trim().toLowerCase()
            .replace(/[^a-z0-9 -]/g, '') // Remove non-alphanumeric, space, or hyphen
            .replace(/\s+/g, '-') // Replace spaces with hyphens
            .replace(/--+/g, '-'); // Replace multiple hyphens with a single hyphen
    }
    var form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            name: site.name || "",
            domain: site.domain || "",
            subdomain: site.subdomain || slugify(team.name),
            domain_type: site.domain_type || "subdomain",
            // items: [],
            landing_config: {
                calendars: ((_b = site.landing_config) === null || _b === void 0 ? void 0 : _b.calendars) || [],
                colors: {
                    bg: ((_d = (_c = site.landing_config) === null || _c === void 0 ? void 0 : _c.colors) === null || _d === void 0 ? void 0 : _d.bg) || "#f3f4f6",
                    hero_bg: ((_f = (_e = site.landing_config) === null || _e === void 0 ? void 0 : _e.colors) === null || _f === void 0 ? void 0 : _f.hero_bg) || "#0c4a6e",
                },
                content: {
                    hero_image: ((_h = (_g = site.landing_config) === null || _g === void 0 ? void 0 : _g.content) === null || _h === void 0 ? void 0 : _h.hero_image) || "",
                    heading: ((_k = (_j = site.landing_config) === null || _j === void 0 ? void 0 : _j.content) === null || _k === void 0 ? void 0 : _k.heading) || "",
                    sub_heading: ((_m = (_l = site.landing_config) === null || _l === void 0 ? void 0 : _l.content) === null || _m === void 0 ? void 0 : _m.sub_heading) || "",
                    info_heading: ((_p = (_o = site.landing_config) === null || _o === void 0 ? void 0 : _o.content) === null || _p === void 0 ? void 0 : _p.info_heading) || "",
                    info_cards: ((_r = (_q = site.landing_config) === null || _q === void 0 ? void 0 : _q.content) === null || _r === void 0 ? void 0 : _r.info_cards.length) > 0
                        ? (_t = (_s = site.landing_config) === null || _s === void 0 ? void 0 : _s.content) === null || _t === void 0 ? void 0 : _t.info_cards
                        : [{ heading: "", content: "" }],
                },
            },
        },
    });
    form.watch(function (value) {
        console.log("form.watch", value);
    });
    function onSubmit(values) {
        console.log(values);
        var method = site.id ? 'put' : 'post';
        var url = site.id ? route('team.site.update', { team: team, site: site }) : route('team.site.store', { team: team });
        router[method](url, values);
    }
    useEffect(function () {
    });
    var _x = useState(((_v = (_u = site.landing_config) === null || _u === void 0 ? void 0 : _u.content) === null || _v === void 0 ? void 0 : _v.info_cards.length) || 1), cardCount = _x[0], setCardCount = _x[1];
    var handleAddCardClick = function () {
        setCardCount(cardCount + 1); // Add a new card
    };
    return (_jsx(AppLayout, __assign({ title: "Calendars", pageTitle: "Landing pages", breadCrumb: _jsx(Breadcrumb, { team: team, site: site }) }, { children: _jsx(Form, __assign({}, form, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(onSubmit), className: "space-y-8" }, { children: [_jsx(FormField, { control: form.control, name: "landing_config.calendars", render: function () { return (_jsxs(FormItem, { children: [_jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx(FormLabel, __assign({ className: "text-base" }, { children: "Calendars" })), _jsx(FormDescription, { children: "Select one or more calendars for your landing page" })] })), bookingCalendars.map(function (bookingCalendar) { return (_jsx(FormField, { control: form.control, name: "landing_config.calendars", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "flex flex-row items-start space-x-3 space-y-0" }, { children: [_jsx(FormControl, { children: _jsx(Checkbox, { checked: (_b = field.value) === null || _b === void 0 ? void 0 : _b.includes(bookingCalendar.id), onCheckedChange: function (checked) {
                                                            var _a;
                                                            return checked
                                                                ? field.onChange(__spreadArray(__spreadArray([], field.value, true), [bookingCalendar.id], false))
                                                                : field.onChange((_a = field.value) === null || _a === void 0 ? void 0 : _a.filter(function (value) { return value !== bookingCalendar.id; }));
                                                        } }) }), _jsx(FormLabel, __assign({ className: "text-sm font-normal" }, { children: bookingCalendar.name }))] }), bookingCalendar.id));
                                    } }, bookingCalendar.id)); }), _jsx(FormMessage, {})] })); } }), _jsx(FormField, { control: form.control, name: "domain_type", render: function (_a) {
                            var field = _a.field;
                            return (_jsxs(FormItem, __assign({ className: "space-y-3" }, { children: [_jsx(FormLabel, __assign({ className: "text-base" }, { children: "Domain type" })), _jsx(FormControl, { children: _jsxs(RadioGroup, __assign({ onValueChange: field.onChange, defaultValue: field.value, className: "flex flex-col space-y-1" }, { children: [_jsxs(FormItem, __assign({ className: "flex items-center space-x-3 space-y-0" }, { children: [_jsx(FormControl, { children: _jsx(RadioGroupItem, { value: "subdomain" }) }), _jsx(FormLabel, __assign({ className: "font-normal" }, { children: "Sub-domain" }))] })), _jsxs(FormItem, __assign({ className: "flex items-center space-x-3 space-y-0" }, { children: [_jsx(FormControl, { children: _jsx(RadioGroupItem, { value: "custom" }) }), _jsx(FormLabel, __assign({ className: "font-normal" }, { children: "Custom domain" }))] }))] })) }), _jsx(FormMessage, {})] })));
                        } }), form.getValues().domain_type == "subdomain" && _jsx(FormField, { control: form.control, name: "subdomain", render: function (_a) {
                            var field = _a.field;
                            return (_jsxs(FormItem, { children: [_jsx(FormLabel, { children: "Subdomain" }), _jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx(FormControl, { children: _jsx(Input, __assign({ type: "text", placeholder: "domain" }, field)) }), _jsx("span", __assign({ className: "ml-2 font-mono text-sm text-gray-400" }, { children: ".ovform.com" }))] })), _jsx(FormDescription, { children: "Please enter the subdomain." }), _jsx(FormMessage, {})] }));
                        } }), form.getValues().domain_type == "custom" && _jsx(FormField, { control: form.control, name: "domain", render: function (_a) {
                            var field = _a.field;
                            return (_jsxs(FormItem, { children: [_jsx(FormLabel, { children: "Subdomain" }), _jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx(FormControl, { children: _jsx(Input, __assign({ type: "text", placeholder: "domain" }, field)) }), _jsx("span", __assign({ className: "ml-2 font-mono text-sm text-gray-400" }, { children: ".ovform.com" }))] })), _jsx(FormDescription, { children: "Please enter the subdomain." }), _jsx(FormMessage, {})] }));
                        } }), _jsx("h2", { children: "Custom content" }), _jsx(FormField, { control: form.control, name: "landing_config.content.heading", render: function (_a) {
                            var field = _a.field;
                            return (_jsxs(FormItem, { children: [_jsx(FormLabel, { children: "Heading" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "Easy and Convenient Animal Health Certificates" }, field)) }), _jsx(FormDescription, { children: "Main heading of the page." }), _jsx(FormMessage, {})] }));
                        } }), _jsx(FormField, { control: form.control, name: "landing_config.content.sub_heading", render: function (_a) {
                            var field = _a.field;
                            return (_jsxs(FormItem, { children: [_jsx(FormLabel, { children: "Sub Heading" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "Appointments in Gidea Park, Romford" }, field)) }), _jsx(FormDescription, { children: "Sub heading of the page." }), _jsx(FormMessage, {})] }));
                        } }), _jsx(FormField, { control: form.control, name: "landing_config.content.info_heading", render: function (_a) {
                            var field = _a.field;
                            return (_jsxs(FormItem, { children: [_jsx(FormLabel, { children: "Information Heading" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "FAQs" }, field)) }), _jsx(FormDescription, { children: "The heading for the information section." }), _jsx(FormMessage, {})] }));
                        } }), 
                    // Render info cards
                    Array.from({ length: cardCount }).map(function (_, index) { return (_jsxs("div", __assign({ className: "border rounded p-4 mb-4" }, { children: [_jsx(FormField, { control: form.control, name: "landing_config.content.info_cards.".concat(index, ".heading"), render: function (_a) {
                                    var field = _a.field;
                                    return (_jsxs(FormItem, { children: [_jsxs(FormLabel, { children: ["Card ", index + 1, " Heading"] }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "Heading ".concat(index + 1) }, field)) }), _jsxs(FormDescription, { children: ["The heading for card #", index + 1, "."] }), _jsx(FormMessage, {})] }));
                                } }), _jsx(FormField, { control: form.control, name: "landing_config.content.info_cards.".concat(index, ".content"), render: function (_a) {
                                    var field = _a.field;
                                    return (_jsxs(FormItem, { children: [_jsxs(FormLabel, { children: ["Card ", index + 1, " Content"] }), _jsx(FormControl, { children: _jsx(Textarea, __assign({ placeholder: "Content ".concat(index + 1) }, field)) }), _jsxs(FormDescription, { children: ["The content for card #", index + 1, "."] }), _jsx(FormMessage, {})] }));
                                } })] }), index)); }), _jsx(Button, __assign({ variant: "outline", onClick: handleAddCardClick }, { children: "Add More Card" })), _jsx(Button, __assign({ type: "submit" }, { children: "Submit" }))] })) })) })));
}
